import axios from 'axios'

/**
 * @desc Fetches all subscription plans
 *
 */
export const fetchSubscriptionPlans = () =>
  axios.get('/authenticated/subscription/plans').then((res) => res.data)

/**
 * @desc Creates a new subscription
 * @param supplierId
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export const createSubscription = (supplierId, payload) =>
  axios
    .post('/authenticated/subscription', payload, {
      params: { supplierId }
    })
    .then((res) => res.data)

/**
 * Generates a portal session link for suppliers to manage existing subscriptions
 * @param supplierId
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export const generateStripeSubscriptionPortalSession = (supplierId, payload) =>
  axios
    .post('/authenticated/subscription/portal-session', payload, {
      params: { supplierId }
    })
    .then((res) => res.data)
